import React, { FC } from 'react'

import { useRouteMatch } from 'react-router'

import { AppRoute } from 'components/components.types'
import MambaLayoutIndex from 'components/layout/MambaLayout/MambaLayoutIndex'
import { inlineNoticePath } from 'components/paths'
import { LocaleSwitch } from 'components/system/LocaleSwitch'
import { redesignedNoticesIdsList } from 'components/uninotice/UniNoticeInlinePage'
import { removeLocaleFromPath2 } from 'functions/language'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useRedesign, useRedesignLayout } from 'hooks/useRedesign'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

const MambaLayoutSwitch: FC<{ routes: AppRoute[] }> = ({ routes }) => {
  const match = useRouteMatch()

  const redesign = useRedesign()
  const redesignLayout = useRedesignLayout()

  const { pathname } = useShallowEqualSelector(
    ({
      router: {
        location: { pathname },
      },
    }) => ({
      pathname,
    })
  )

  const innerElement = <LocaleSwitch matchPath={match?.path} routes={routes} />

  const pathWithoutLocale = removeLocaleFromPath2(pathname)

  // startsWith используется, потому что на этих страницах могут быть открыты модалы
  const redesignedNoticeId = redesignedNoticesIdsList.find((noticeId) =>
    pathWithoutLocale.startsWith(mergeAllUrls(inlineNoticePath, noticeId))
  )

  const redesignedPath = redesign && Boolean(redesignedNoticeId)

  return (
    <MambaLayoutIndex
      redesignLayout={redesignLayout}
      redesignedPath={redesignedPath}
    >
      {innerElement}
    </MambaLayoutIndex>
  )
}

export default MambaLayoutSwitch
